export default __webpack_public_path__ + "static/media/piano intro_1.1363a237.wav";